<template>
  <InteressesLayout>
    <template #cards>
      <v-flex v-for="(card, index) in cards" :key="index" fluid xs4>
        <cbm-card
          :number-text="card.value"
          :title="card.text"
          :boolean-loader="loading"
          :is-currency="card.isCurrency"
          :percent-description="card.underText"
          unset-percentage-colors
          simple-card
        />
      </v-flex>
    </template>
    <template v-slot:table="{ tableList }">
      <mf-loading :loader="['last-update', 'primeiro-registro', 'interesses-por-genero']" :boolean-loader="loading" loader-type="table">
        <v-data-table
          v-if="tableList === 'cupons'"
          :items="orderDescList(listaDeInteressesGenero, 'NUM_ITENS_TOTAL')"
          :items-per-page-options="rowsPerPageArray"
          :headers="headersCupons"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item['DES_CATEGORIA'] }}</td>
              <td class="text-center">
                <listagem :nome-categoria="item['DES_CATEGORIA']" :categoria-produto="item['COD_ID_CATEGORIA_PRODUTO']" :value="item['NUM_ITENS_TOTAL']" />
              </td>
              <td class="text-center">
                <listagem
                  nome-lista="Lista de Homens"
                  :nome-categoria="item['DES_CATEGORIA']"
                  categoria-genero="M"
                  :categoria-produto="item['COD_ID_CATEGORIA_PRODUTO']"
                  :value="item['NUM_ITENS_M']"
                />
              </td>
              <td class="text-center">
                <listagem
                  nome-lista="Lista de Mulheres"
                  :nome-categoria="item['DES_CATEGORIA']"
                  categoria-genero="F"
                  :categoria-produto="item['COD_ID_CATEGORIA_PRODUTO']"
                  :value="item['NUM_ITENS_F']"
                />
              </td>
            </tr>
          </template>
        </v-data-table>

        <v-data-table
          v-else
          :items="orderDescList(listaDeInteressesGenero, 'VAL_FATURAMENTO_TOTAL')"
          :items-per-page-options="rowsPerPageArray"
          :headers="headersFaturamento"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item['DES_CATEGORIA'] }}</td>
              <td class="text-center">{{ item['VAL_FATURAMENTO_TOTAL'] | localeString(2) | currency }}</td>
              <td class="text-center">{{ item['VAL_FATURAMENTO_M'] | localeString(2) | currency }}</td>
              <td class="text-center">{{ item['VAL_FATURAMENTO_F'] | localeString(2) | currency }}</td>
            </tr>
          </template>
        </v-data-table>
      </mf-loading>
    </template>
  </InteressesLayout>
</template>

<script>
import InteressesLayout from '@/modules/clientes/interesses/layouts/Index.vue'
import CbmCard from '@/components/CbmCard.vue'
import Listagem from '@/components/ListagemClientes.vue'
import { assertArray, localeString } from '@/config/helpers.js'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import InteressesMixins from '@/modules/clientes/interesses/mixins/index'

export default {
  components: {
    InteressesLayout,
    CbmCard,
    Listagem,
  },
  mixins: [InteressesMixins],
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapState({
      listaDeInteressesGenero: (state) => state.clientes.listaInteressesGenero,
      stateTicketMedio: (state) => state.clientes.ticketMedio,
      stateFilters: (state) => state.filters,
    }),
    cards() {
      return [
        {
          text: 'Homens',
          value: localeString(this.ticketMedio.homens || 0, 0),
          isCurrency: true,
          underText: 'Ticket médio',
          loader: ['last-update', 'primeiro-registro', 'ticket-medio', 'ticket-medio-object'],
        },
        {
          text: 'Mulheres',
          value: localeString(this.ticketMedio.mulheres || 0, 0),
          isCurrency: true,
          underText: 'Ticket médio',
          loader: ['last-update', 'primeiro-registro', 'ticket-medio', 'ticket-medio-object'],
        },
        {
          text: 'Outros / Indefinido',
          value: localeString(this.ticketMedio.outros || 0, 0),
          isCurrency: true,
          underText: 'Ticket médio',
          loader: ['last-update', 'primeiro-registro', 'ticket-medio', 'ticket-medio-object'],
        },
      ]
    },
    ticketMedio() {
      this.$wait.start('ticket-medio-object')
      let object = {}
      for (let state of assertArray(this.stateTicketMedio)) {
        switch (state['DES_SEXO_CLIENTE']) {
          case ' ':
            object.outros = state['VAL_TICKET_MEDIO']
            break
          case 'M':
            object.homens = state['VAL_TICKET_MEDIO']
            break
          case 'F':
            object.mulheres = state['VAL_TICKET_MEDIO']
            break
        }
      }
      this.$wait.end('ticket-medio-object')
      return object
    },
    headersCupons() {
      return [
        {
          text: 'Categorias',
          value: 'DES_CATEGORIA',
        },
        {
          text: 'Quantidade total',
          align: 'center',
          value: 'NUM_ITENS_TOTAL',
        },
        {
          text: 'Homens',
          align: 'center',
          value: 'NUM_ITENS_M',
        },
        {
          text: 'Mulheres',
          align: 'center',
          value: 'NUM_ITENS_F',
        },
      ]
    },
    headersFaturamento() {
      return [
        {
          text: 'Categorias',
          value: 'DES_CATEGORIA',
        },
        {
          text: 'Faturamento total',
          align: 'center',
          value: 'VAL_FATURAMENTO_TOTAL',
        },
        {
          text: 'Homens',
          align: 'center',
          value: 'VAL_FATURAMENTO_M',
        },
        {
          text: 'Mulheres',
          align: 'center',
          value: 'VAL_FATURAMENTO_F',
        },
      ]
    },
  },
  async mounted() {
    this.loading = true
    await this.getData()
    this.$nextTick(() => {
      this.$bus.$on('filter', this.getData)
      this.setFilters({ ...this.stateFilters, pessoa: '' })
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      listaInteressesPorGenero: 'interesses-por-genero',
      clientesTicketMedio: 'ticket-medio',
      setFilters: 'set-filters',
      empresaPrimeiroRegistro: 'primeiro-registro',
    }),
    async getData() {
      try {
        this.loading = true
        const filter = {
          unidades: this.stateFilters.unitsConfiguration,
          tipo_pessoa: 'F',
          categoria_cliente: this.stateFilters.cliente,
          fidelidade: this.stateFilters.fidelidade,
          segmentos: this.stateFilters.segmentos,
        }
        if (this.stateFilters.data?.[0].length > 0) {
          filter.date = this.stateFilters.data
        }
        await this.listaInteressesPorGenero(filter)
        await this.clientesTicketMedio({ ...filter, group_field: 'genero' })
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
